import { Component } from '@angular/core';

@Component({
    selector: 'hvac-accordion-body',
    templateUrl: './accordion-body.component.html',
    styleUrls: ['./accordion-body.component.scss']
})
export class AccordionBodyComponent {
}
